import { configureStore } from '@reduxjs/toolkit'
import {
  useDispatch as useDispatchRedux,
  useSelector as useSelectorRedux,
} from 'react-redux'

import onboardingReducer from './slices/onboarding'
import layoutReducer from './slices/layout'
import remoteAppReducer from './slices/remoteApp'
import cacheReducer from './slices/cache'
import appUrlMiddleware from './middlewares/appUrlMiddleware'
import { SentryRedux } from '@Utils/Sentry'

const store = configureStore({
  reducer: {
    onboarding: onboardingReducer,
    layout: layoutReducer,
    remoteApp: remoteAppReducer,
    cache: cacheReducer,
  },
  devTools: CURRENT_ENV !== 'prod',
  // Tokens are session-scoped: AppConnectGuard re-issues them each load via
  // the Shopify ID-token exchange. localStorage persistence (was
  // 'renaissance:auth:tokens') was intentionally dropped — any new app load
  // gets fresh tokens via appUrlMiddleware decoding the embedded ?token=.
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend([appUrlMiddleware.middleware]),
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(SentryRedux),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useDispatch = useDispatchRedux.withTypes<AppDispatch>()
export const useSelector = useSelectorRedux.withTypes<RootState>()

export default store
